/* eslint-disable */
import { callStatic, ReviewsListResponse } from 'services/api-service'

/**
 * List of reviews
 *
 * @method
 * @name ApiService#reviewsList
 * @param {string} sku - 
 * @param {integer} offset - 
 * @param {integer} limit - 
 * @param {string} filters - Encoded JSON of filters.  Example before being encoded: {"md":true,"rt":[1,2,3],"sp":[{"7":[2,3]},{"14":[1]}],"dm":[{"5":[1,4]},{"3":[2,3,4]}],"att":[{"2":[1]},{"3":[1,2]}]}
 * @param {string} sort - Default value and which options are available depends on site settings:
 * RECENT
 * L_RATED
 * H_RATED
 * OLDEST
 * HELPFUL
 * LOCAL

 * @param {boolean} includeRelated - 
 * @param {boolean} includeFilters - 
 * @param {string} searchText - 
 */
function reviewsList(parameters: {
  sku: string
  offset: number
  limit: number
  filters: string
  sort: string
  includeRelated: boolean
  includeFilters: boolean
  searchText?: string
}): Promise<ReviewsListResponse> {
  return callStatic<ReviewsListResponse>(
    '/sitedata/{siteKey}/{sku}/d/review/{locale}/{offset}/{limit}/{filters}/{sort}/{includeRelated}/{includeFilters}/{searchText}',
    parameters,
    ['sku', 'offset', 'limit', 'filters', 'sort', 'includeRelated', 'includeFilters']
  )
}

export default { reviewsList }
